import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import { useApiError } from '../useApiError';
export const userMessage = (Id: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // //console.log("usePaymethodcontext---------", context.useApiError);
  const { set: setError } = useApiError();

  const unResult = sharedRef(null, `usePay-${Id}`);
  const loading = sharedRef(false, `usePay-loading-${Id}`);
  const error = sharedRef(null, `usePay-error-${Id}`);

  // 未读站内信列表
  const unReadMsg = async (customQuery) => {
    try {
      loading.value = true;
      // console.log("未读站内信参数：", customQuery);
      const res = await context.$xbuy.api.UnReadMessageList(customQuery);
      // console.error('未读站内信返回结果：', res);
      if (res && res.code === 0) {
        unResult.value = res.data;
        error.value = null;
      } else {
        error.value = res.message;
        setError({ code: res.code, message: res.message });
      }
    } catch (err) {
      error.value = err.message;
    } finally {
      loading.value = false;
    }
  };

  const readResult = sharedRef(null, `usePay-${Id}`);
  const readLoading = sharedRef(false, `usePay-loading-${Id}`);
  const readError = sharedRef(null, `usePay-error-${Id}`);

  // 阅读站内信
  const readMsg = async (customQuery) => {
    try {
      readLoading.value = true;
      // console.log("阅读站内信参数：", customQuery);
      const res = await context.$xbuy.api.ReadMessage(customQuery);
      // console.error('阅读站内信返回结果：', res);
      if (res && res.code === 0) {
        readResult.value = res.data;
        readError.value = null;
      } else {
        readError.value = res.message;
        setError({ code: res.code, message: res.message });
      }
    } catch (err) {
      readError.value = err.message;
    } finally {
      readLoading.value = false;
    }
  };

  return {
    unReadMsg,
    unResult: computed(() => unResult.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value),
    readMsg,
    readResult: computed(() => readResult.value),
    readLoading: computed(() => readLoading.value),
    readError: computed(() => readError.value)
  };
};
